import * as Crypto from 'expo-crypto';

/**
 * ID opaco de 128 bits (16 bytes) em hex.
 *
 * Fonte CSPRNG (expo-crypto, nativo) — NÃO `Math.random()`. Dois aparelhos do mesmo
 * dono geram IDs offline para a mesma base (sync multi-dispositivo — ver docs/features/SYNC.md
 * e ADR 0030); um gerador com viés elevaria o risco de colisão entre eles. Mesma fonte de
 * aleatoriedade já usada pela cifra de backup (lib/backupCrypto `randomBytes`). Formato
 * inalterado (32 chars hex), só a entropia muda.
 */
export function generateId(): string {
    return Array.from(Crypto.getRandomBytes(16))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
